<div class="image-viewer-container"
     (wheel)="onWheel($event)"
     (touchstart)="onTouchStart($event)"
     (touchmove)="onTouchMove($event)">
  <img [src]="imageUrl"
       [style.transform]="'scale(' + zoom + ')'"
       alt="Image"
       draggable="false" />
  <div class="zoom-controls">
    <button ion-button (click)="zoomIn()">+</button>
    <button ion-button (click)="zoomOut()">-</button>
    <button ion-button (click)="resetZoom()">Reset</button>
  </div>
</div>